<template>
  <div  :class="[{bpanel2:mode>0} ,{bpanel:mode==0}]">


      <!--  -->
      <div :class="[{chartnamepanel2:mode>0} ,{chartnamepanel:mode==0}]">
       <p> {{ chartname }}</p>
      </div>

      <div class="smallchart">
        <dv-water-level-pond :config="config" :class="[{wechart2:mode>0} ,{wechart:mode==0}]" style="width:90px;height:90px;margin: auto;" />
      </div>
 
  </div>
</template>

<script>


var myChart;

const fullWidth = 300
const borderGap = 0
const borderWidth = 3
const usefulWidth = fullWidth - (borderGap + borderWidth) * 2

const pieceLength = [0.25, 0.5, 0.25]
const pieceGap = 0

const lineDash = pieceLength
  .map(l => [usefulWidth * l, pieceGap])
  .reduce((all, current) => [...all, ...current], [])



export default {
  name: 'WaterCharts',
  components: {

  },
  props: {
    'mode': Number,
    'oee': Number,
    'chartname': String,
    'shap': Number,
    'id': String
  },
  data() {
    return {
      oeehh: 0,
      oee1hh: 0,
      durtime: 30,
      namesize: 'font-size:' + this.size,
      config: {
        data: [this.oee * 100],
        shape: 'round'
      },

    }
  },
  methods: {

  },
  mounted() {

  },
  watch: {
    'oee': {
      handler(newVal, oldName) {
        if(newVal == undefined) return;
        this.$data.config.data[0] = Number(newVal) * 100
        this.oeehh = Number(newVal);
        this.$data.config = { ...this.$data.config }
      },
      immediate: true //true就表示会立即执行
      , deep: true //为true，表示深度监听，这时候就能监测到a值变化

    },
   
  }
}
</script>

<style lang="less">

.smallchart {
  width: 100%;
  height: 100%;
}


.chartnamepanel {
  width: 100%;
  font-size: 20px;
  text-align: center;
  margin-bottom: 2px;
}

.chartnamepanel2 {
  width: 100%;
  font-size: 16px;
  text-align: center;

}

.bpanel {
  width:100%; height:100%; margin: 5px;position: relative;
}


.bpanel2 {
  background-color: #222233cc;   border-radius: 10px;
  width:100%; height:120%; margin: 0px;position: relative;
}


.wechart {
  width:120px;height:120px;margin: auto;margin-top: 10px;
}

.wechart2 {
  
}


</style>
